import { motion } from "framer-motion";

const logos = [
  {
    name: "Patrick Immobilier",
    src: "https://customer-assets.emergentagent.com/job_c593de8c-5e56-414d-9245-0539b94865dd/artifacts/v3aph8bg_Logo-Patrick-Immobilier-2400px.png",
  },
  {
    name: "Gex & Dorthe Ingénieurs",
    src: "https://customer-assets.emergentagent.com/job_c593de8c-5e56-414d-9245-0539b94865dd/artifacts/8mkiehr3_gexetdorthe.png",
    size: "h-8 md:h-10 w-auto",
    invert: true,
  },
  {
    name: "CleanBulle Sàrl",
    src: "https://customer-assets.emergentagent.com/job_c593de8c-5e56-414d-9245-0539b94865dd/artifacts/w9h0fa3j_logo_cleanbulle_fondblanc%20%282%29.png",
  },
];

export default function ClientLogos() {
  return (
    <section data-testid="client-logos" className="py-10 bg-white border-b border-slate-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-center text-xs uppercase tracking-widest text-slate-400 mb-8 font-medium"
        >
          Ils nous font confiance
        </motion.p>
        <div className="flex items-center justify-center gap-12 md:gap-20 flex-wrap">
          {logos.map((logo, i) => (
            <motion.div
              key={logo.name}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 + i * 0.15, duration: 0.5 }}
              className="flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                data-testid={`client-logo-${i}`}
                className={`object-contain opacity-60 hover:opacity-100 transition-opacity duration-300 ${logo.noGray ? "" : "grayscale hover:grayscale-0"} ${logo.invert ? "brightness-0 hover:brightness-100" : ""} ${logo.size || "h-12 md:h-16"}`}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
